<template>
    <v-chip :color="count ? color : 'disabled darken-1'" dark label small class="count-chip px-2">
        {{ count }}
    </v-chip>
</template>


<script>
export default {
    name: 'CountCard',
    props: {
        count: Number,
        color: {
            type: String,
            default: 'primary'
        },
    },
    components: {},

    data() {
        return {};
    },

    methods: {},

    computed: {},

    watch: {},
};
</script>


<style lang='scss' scoped>
.count-chip {
    min-width: 20px;
    height: 20px;
    font-size: 13px;
    line-height: 1.5;
    justify-content: center;
}
</style>